import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UserRoles } from 'my-account/constants';
import { Subscription } from 'rxjs';
import { Cloudinary } from 'services/cloudinary';
import { XmStore, XmStoreUtil } from 'services/store';
import { Util } from 'services/util';
import { CmsDataDetail } from 'store/cms/models';


@Component({
    selector: 'xm-call-guard',
    styleUrls: ['./xm-call-guard.scss'],
    templateUrl: './xm-call-guard.html',
    standalone: false
})

export class XmCallGuardComponent implements OnInit, OnDestroy {
    @Input() public userRole: string;
    
    public pageData: CmsPlanSevenXmCallGuard;
    public imageOptions: MediaImageOptions;
    public shouldDisableButton: boolean = false;

    private subscriptions: Subscription[] = [];
    private xmStore: XmStore;

    constructor(xmStore: XmStore) {
        Object.assign(this, { xmStore });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsDataDetail>(CmsDataDetail), (pageData: CmsDataDetail) => {
            this.pageData = pageData.planSevenXmCallGuard;

            this.imageOptions = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData.icon)
            };

        }));

        this.shouldDisableButton = this.userRole === UserRoles.VIEWER;
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }
}
